<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <v-btn color="primary" rounded small @click="verifyUserBrowser" :loading="loading" :disabled="buttonDisabled">
            {{ buttonText }}
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </template>
      <div>
        <div v-if="!buttonDisabled">
          Entrar na sala de atendimento
        </div>
        <div v-else>
          Acesso à consulta liberado somente no dia {{ dateAppointment }} das {{ enterTimeStart }} até
          {{ enterTimeLimit }}
        </div>
      </div>
    </v-tooltip>

    <FormDadosAtendimento v-if="dialog" @dados-confirmados="enterOnQueue" />
  </div>
</template>

<script>
import { ptBR } from 'date-fns/locale'
import FormDadosAtendimento from '../AtendimentoVirtual/FormDadosAtendimento.vue'
import { format } from 'date-fns'

export default {
  name: 'AgendamentoCardButton',
  props: {
    idAtendimento: {
      type: String
    },
    statusAtendimento: {
      type: String
    },
    tipoAtendimento: {
      type: String
    },
    dtAtendimento: {
      type: Date
    }
  },
  components: {
    FormDadosAtendimento
  },
  data() {
    return {
      buttonText: 'Acessar consulta',
      minutesBeforeAppointment: 60,
      minutesAfterAppointment: 60,
      agendamentoDate: null,
      hintText: '',
      loading: false,
      dialog: false,
      buttonDisabled: true,
      timer: false,
      supportedBrowsers: [
        {
          nome: 'Google Chrome',
          test: ua => ua.includes('Chrome')
        },
        {
          nome: 'Mozilla Firefox',
          test: ua => ua.includes('Firefox')
        },
        {
          nome: 'Microsoft Edge',
          test: ua => ua.includes('Edg')
        },
        {
          nome: 'Opera',
          test: ua => ua.includes('OPR')
        }
      ]
    }
  },
  computed: {
    dateAppointment() {
      const appointmentDate = new Date(this.dtAtendimento)
      return format(appointmentDate, 'dd/MM/yyyy', { locale: ptBR })
    },
    enterTimeStart() {
      const originalDate = new Date(this.dtAtendimento)
      const dateStart = new Date(originalDate.getTime() - this.minutesBeforeAppointment * 60000)
      return dateStart.toLocaleTimeString('pt-br', { hour: '2-digit', minute: '2-digit' })
    },
    enterTimeLimit() {
      const originalDate = new Date(this.dtAtendimento)
      const dateStart = new Date(originalDate.getTime() + this.minutesAfterAppointment * 60000)
      return dateStart.toLocaleTimeString('pt-br', { hour: '2-digit', minute: '2-digit' })
    }
  },
  methods: {
    verifyUserBrowser() {
      const userAgent = navigator.userAgent
      const isSupported = this.supportedBrowsers.find(browser => browser.test(userAgent))
      if (isSupported) {
        this.dialog = true
      } else {
        this.$showErrorMessage(
          'Este navegador não suporta essa funcionalidade, por favor utilize um dos seguintes: Opera, Mozilla Firefox ou Microsoft Edge '
        )
        this.$router.push({ name: 'dashboard' })
      }
    },
    isWithinTimeRange() {
      const currentDate = new Date()
      const appointmentDate = new Date(this.dtAtendimento)
      // Calcula a diferença em milissegundos
      const differenceInMilliseconds = appointmentDate - currentDate

      // Converte a diferença em minutos
      const differenceInMinutes = differenceInMilliseconds / (1000 * 60)

      if (differenceInMinutes < this.minutesBeforeAppointment && differenceInMinutes > -this.minutesAfterAppointment) {
        this.buttonDisabled = false
        return true
      } else {
        this.buttonDisabled = true
        return false
      }
    },
    async enterOnQueue() {
      if (!this.disabled) {
        try {
          this.loading = true
          // const { data } = await meetingService.enterOnQueue(this.idAtendimento)
          this.$router.push({ name: 'fila-atendimento-ambulatorial', params: { idAtendimentoAmbulatorial: this.idAtendimento } })
        } catch ({ response }) {
          this.$showErrorMessage(response.data.message)
          this.dialog = false
        } finally {
          this.loading = false
        }
      }
    }
  },
  mounted() {
    this.isWithinTimeRange()
    this.timer = setInterval(this.isWithinTimeRange, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped></style>
